// Responsable des imports mensuels (table privée `import_owners`) : lui seul voit le menu et la page « Imports ».
import { useQuery } from "@tanstack/react-query";

import { getSupabaseClient } from "../providers/supabase/supabase";

export const useIsImportsOwner = () =>
  useQuery({
    queryKey: ["is_imports_owner"],
    staleTime: Infinity,
    queryFn: async () => {
      const { data, error } = await getSupabaseClient().rpc("is_imports_owner");
      if (error) throw error;
      return data === true;
    },
  });
